module.exports = __webpack_public_path__ + "static/media/print.b4ccf220.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/print.svg
// module id = 246
// module chunks = 0